import React, { useState } from 'react'
import ChooseUs from "../../../assets/images/choose-us.png"
import VideoBg from "../../../assets/images/Whychooseus.jpg"
import ModalVideo from 'react-modal-video'
import "react-modal-video/css/modal-video.css";

const ChooseSection = ({ Line }) => {

    const points = [
        {
            title: "Attention to Detail",
            description: "We don’t just clean; we perfect. Our team takes the time to ensure every surface is immaculate."
        },
        {
            title: "Eco-Friendly Practises",
            description: "We use environmentally safe products to protect both your space and the planet."
        },
        {
            title: "Customised Solutions",
            description: "Every business is unique, and so are your cleaning needs. We provide personalized cleaning plans to suit your requirements."
        },
        {
            title: "Reliability You Can Trust",
            description: "We pride ourselves on our professionalism, punctuality, and commitment to excellence."
        }
    ]

    const [show, setShow] = useState(false)
    return (
        <div>
            <div className="rs-choose choose-style1 bg8 pt-120 pb-120 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="align-items-start row y-middle">
                        <div className="col-lg-6 md-mt-50">
                            <div className="choose-us-section">
                                
                                {/* <div className="choose-img mb-30">
                                    <img src={ChooseUs} alt="" />
                                </div> */}
                                <div className="video-img text-center">
                                    <img src={VideoBg} alt="" className='w-100 object-fit-cover'  style={{objectPosition:"top"}}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 pr-85 md-pr-15">
                            <div className="sec-title">
                                <span className="sub-text">Why Choose Us?</span>
                                <h2 className="title">
                                    Expert in Cleaning Services <br /><span>Reasons</span> to Choose Us
                                </h2>
                                <div className="line-img new wow fadeInUp" >
                                    <img src={Line} alt="Images" />
                                </div>
                                <div className="rs-features-list mt-3">
                                    {points?.map((point, i) => {
                                        return (
                                            <div className="feature-item mb-3" key={i}>
                                                <div className="feature-icon">
                                                    <i className="bi bi-check-lg"></i>
                                                </div>
                                                <div className="rs-feature-text">
                                                    <h4 className="title mb-1">{point?.title}</h4>
                                                    <p className="desc">{point?.description}</p>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ModalVideo
                channel="youtube"
                youtube={{ mute: 0, autoplay: true }}
                isOpen={show}
                videoId={"LpdRAyIGg8I"}
                onClose={() => setShow(false)}
            />

        </div >
    )
}

export default ChooseSection
